export default __webpack_public_path__ + "static/media/maduro-1Open.4e9b38fb.jpg";